import { ElementData, ElementDataValue, FormElement } from '../../lib/types'
import React from 'react'
import ChangeIndicator from './change-indicator'
import { Tooltip } from '@carbon/react'
import { Information } from '@carbon/icons-react'
import { getCaseInsensitive } from '../../lib/get-id'

type Props = {
    original: ElementData
    data: ElementData
    prevData?: ElementData
    element: FormElement
    onChange: (field: string, value: ElementDataValue) => void
}

export default function FormCheckboxElement(props: Props) {
    const { element, data, prevData, original, onChange } = props
    let changed =
        getCaseInsensitive(data, element.field || '') !== getCaseInsensitive(original, element.field || '') ||
        (prevData ? getCaseInsensitive(data, element.field || '') !== getCaseInsensitive(prevData, element.field || '') : false)

    return (
        <div className='mt-2'>
            <label className='font-bold text-blue-700'>
                {element.label || element.field}
                {!element.readonly && <ChangeIndicator changed={changed} />}
                {changed && prevData && (
                    <Tooltip
                        align='bottom'
                        label={getCaseInsensitive(prevData, element.field || '') + ' → ' + getCaseInsensitive(data, element.field || '')}
                    >
                        <span className='cursor-pointer ml-1 flex flex-row items-center'>
                            <Information />
                        </span>
                    </Tooltip>
                )}
            </label>
            <div>
                <input
                    type='checkbox'
                    checked={!!getCaseInsensitive(data, element.field || '')}
                    onChange={(e) =>
                        !element.readonly && onChange(element.field!, e.target.checked)
                    }
                    style={{ borderColor: changed ? 'Highlight' : '#ADB0B3' }}
                    readOnly={element.readonly}
                />
            </div>
        </div>
    )
}
